console.log('init_player_of_match.js loaded!');

/* css for the specific page */
import "./pages-assets/games/player-of-match/player-of-match.css";


   

/* scripts for the specific page */
import "./pages-assets/games/player-of-match/player-of-match.js";
